import {
    Box,
    LinearProgress
} from '@mui/material';
import { enqueueSnackbar, useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, AlertDescription, AlertTitle } from 'src/@/components/ui/alert';
import { Card, CardContent, CardTitle, CardHeader, CardDescription } from 'src/@/components/ui/card';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import actionStatusConnectionWhatsapp from 'src/actions/clientes/actionCheckConnectionWhatsapp';
import actionFecharSessaoWhatsapp from 'src/actions/clientes/actionFecharSessaoWhatsapp';
import actionStartSessionWhatsapp from 'src/actions/clientes/actionStartSessionWhatsapp';
import Iconify from 'src/components/Iconify';
import { setLoadingQrcodeWhatsapp, setQrcode, setStatusQrcode } from 'src/redux/slices/global';
// @mui

DialogWhatsappConexao.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
};

export default function DialogWhatsappConexao({ channel }) {
    const { enqueueSnackbar } = useSnackbar();
    const { qrcode, loadingQrcodeWhatsapp, statusQrcodeRead } = useSelector((state) => state.global);
    //const [isSessionStart, setIsSessionStart] = useState(null)
    let isSessionStart;

    const [seconds, setSeconds] = useState(60);
    const [isRunning, setIsRunning] = useState(false);
    const dispatch = useDispatch();
    const [isCounting, setIsCounting] = useState(false); // Estado para controlar se a contagem está ativa



    useEffect(() => {

        if (statusQrcodeRead === 'qrReadSuccess') {
        }

        if (statusQrcodeRead === 'qrReadError') {
            dispatch(setQrcode(null));
        }

        if (qrcode) {
            setIsCounting(true);
        }

    }, [statusQrcodeRead, qrcode]);

    async function closeSessionWhatsapp() {
        try {
            await actionFecharSessaoWhatsapp(`?sessao=${channel?.sessao}&canal=whatsapp`);
        } catch (error) {

        }
    }

    useEffect(() => {
        let timer;
        if (isCounting && seconds > 0) {
            timer = setInterval(() => {
                setSeconds(prevSeconds => prevSeconds - 1);
            }, 1000);
        } else if (seconds === 0) {
            setIsCounting(false);
            dispatch(setQrcode(null));
            setIsRunning(true);
            setSeconds(60);
            dispatch(setLoadingQrcodeWhatsapp(false));
            closeSessionWhatsapp();
        }
        return () => clearInterval(timer);
    }, [isCounting, seconds]);



    async function statusSessionWhatsapp() {
        try {
            let querys = `?sessao=${channel?.sessao}&canal=whatsapp`;
            const response = await actionStatusConnectionWhatsapp(querys);
            console.log(response.data.data.qrcode)

            if (response.data.data.status === 'QRCODE') {
                dispatch(setStatusQrcode('notLogged'));
                dispatch(setQrcode(response.data.data.qrcode));
                dispatch(setLoadingQrcodeWhatsapp(false));

            } else if (response.data.data.status === 'CONNECTED') {
                window.location.href = "/chats/chat"
            } if (response.data.data.status === 'CLOSED') {
                console.log('sessão encerrada')
            }
            return response.data.data.status

        } catch (error) {

        }
    }


    async function startSessionWhatsapp() {
        try {
            // setQrcode(null);
            // setLoadingQrcodeWhtsapp(true);
            dispatch(setLoadingQrcodeWhatsapp(true))

            let querys = `?sessao=${channel?.sessao}&canal=whatsapp&deletar_sessao=1&fechar_sessao=1`;
            // const response = await actionCheckConnectionWhatsapp(querys);
            setIsRunning(true);

            // if (response.data.data.status) {
            //     return alert('O número já está em uso');
            // }

            try {
                let data = {
                    "webhook": null,
                    "waitQrCode": true,
                    "closeSession": true
                };
                await actionStartSessionWhatsapp(querys, data);
                isSessionStart = 1;

                setTimeout(() => {
                    dispatch(setQrcode(null));
                    setIsRunning(true);
                    setSeconds(60);
                    dispatch(setLoadingQrcodeWhatsapp(false))
                }, 120000);


            } catch (error) {
                dispatch(setLoadingQrcodeWhatsapp(false))
                enqueueSnackbar('Erro ao iniciar sessão, tente novamente', { variant: 'error' });
                console.log(error);
            }

        } catch (error) {
            console.log(error);
            alert('Erro ao iniciar sessão, se persistir contate o suporte');
        }
    }


    return (
        <div className="flex flex-row gap-4">
            <div className="w-full">
                <Card className="mt-4 rounded-xl border border-gray-100 shadow-sm bg-white">
                    <CardHeader>
                        <CardTitle className="text-lg font-semibold text-gray-900">{channel?.nome}</CardTitle>
                        <CardDescription className="pt-2 text-sm text-gray-500">
                            Assita a nossa aula <a href="https://rebrand.ly/colhendoqrcode" target="_blank" rel="noreferrer" className="text-[#7C3AED] hover:text-[#6D28D9] font-bold hover:underline">clicando aqui</a> e siga os passos abaixo para conectar seu whatsapp.
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <ul className="my-3 ml-6 list-disc [&>li]:mt-1 mb-3 text-sm text-gray-700">
                            <li>Abra seu aplicativo whatsapp</li>
                            <li>Abra o leitor de qrcode</li>
                            <li>Clique no botao e aguarde o qrcode na tela</li>
                            <li>Scaneie o Qrcode e aguarde</li>
                        </ul>
                        <Alert className="mt-3 rounded-lg border border-amber-200 bg-amber-50 text-amber-900">
                            <Iconify icon="mdi:alert-circle" className="text-amber-600" />
                            <AlertTitle className="ml-2 font-semibold">Atenção</AlertTitle>
                            <AlertDescription className="ml-2">
                                O Qrcode expira em 60 segundos, caso não consiga ler, clique em gerar qrcode novamente.
                            </AlertDescription>
                        </Alert>

                        <div className="w-full mt-10 flex flex-col items-center">
                            {statusQrcodeRead !== 'notLogged' && (
                                statusQrcodeRead === 'qrReadSuccess' && (
                                    <Box sx={{ width: '50%', mb: 2 }}>
                                        <LinearProgress sx={{ backgroundColor: '#EDE9FE', '& .MuiLinearProgress-bar': { backgroundColor: '#7C3AED' } }} />
                                        <span className="text-xs text-gray-500 mt-2 block text-center">leitura feita com sucesso, carregando mensagens...</span>
                                    </Box>
                                )
                            )}
                            <div className="flex flex-col justify-center gap-4 items-center">

                                {isCounting && (
                                    <small className="text-sm font-medium leading-none text-gray-700">Qrcode expira em {seconds} segundos</small>

                                )}
                                <Box sx={{ display: 'grid' }}>
                                    {!qrcode ? (
                                        <Box sx={{ height: 200, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                            <ButtonLoading
                                                loading={loadingQrcodeWhatsapp}
                                                onClick={() => startSessionWhatsapp()}
                                                className="bg-[#7C3AED] hover:bg-[#6D28D9] text-white rounded-lg px-6 h-10"
                                            >
                                                Gerar Qrcode
                                            </ButtonLoading>
                                        </Box>
                                    ) : (
                                        statusQrcodeRead === "notLogged" && qrcode && (
                                            <img
                                                style={{ height: 250, width: 250 }}
                                                src={`${qrcode}`}
                                                loading={"lazy"}
                                                alt="QR Code"
                                                className="rounded-lg border border-gray-100 p-2"
                                            />
                                        )
                                    )}
                                </Box>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}


